module.exports = __webpack_public_path__ + "static/img/yy-bg.5d8d6116.png";